/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ChildBabyIcon20Solid = forwardRef('ChildBabyIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }),
        React.createElement("path", { d: "M1.116 3.116a1.25 1.25 0 0 1 1.768 0L7.768 8h4.464l4.884-4.884a1.25 1.25 0 0 1 1.768 1.768L14 9.768V12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9.768L1.116 4.884a1.25 1.25 0 0 1 0-1.768Z" }),
        React.createElement("path", { d: "M7.73 15.904a1.25 1.25 0 1 0-.96-2.308l-1.917.799a2 2 0 0 0-.582 3.32l2.134 1.956a1.25 1.25 0 1 0 1.69-1.842L6.537 16.4l1.194-.497Z" }),
        React.createElement("path", { d: "M13.23 13.596a1.25 1.25 0 1 0-.96 2.308l1.193.497-1.558 1.428a1.25 1.25 0 1 0 1.69 1.842l2.134-1.956a2 2 0 0 0-.582-3.32l-1.916-.799Z" })));
});
